import React, { useMemo } from 'react';
import { createTheme, ThemeProvider, useTheme } from '@material-ui/core/styles';

/** One field style for the editor, including its portalled dialogs and lesson. */
const EditorControlsTheme = ({ children }) => {
  const baseTheme = useTheme();
  const theme = useMemo(() => createTheme(baseTheme, {
    overrides: {
      MuiOutlinedInput: {
        root: {
          minHeight: 40,
          fontSize: 14,
          lineHeight: '24px',
          borderRadius: baseTheme.shape.borderRadius,
          backgroundColor: baseTheme.palette.background.paper,
          '&:hover $notchedOutline': { borderColor: baseTheme.palette.text.primary },
          '&$focused $notchedOutline': { borderColor: baseTheme.palette.primary.dark, borderWidth: 2 },
          '&$error $notchedOutline': { borderColor: baseTheme.palette.error.main },
          '&$disabled': { backgroundColor: baseTheme.palette.action.disabledBackground },
          '&$disabled $notchedOutline': { borderColor: baseTheme.palette.action.disabled },
        },
        notchedOutline: { borderColor: baseTheme.palette.text.secondary },
        input: { padding: '8px 12px', height: '24px', boxSizing: 'content-box' },
        inputMarginDense: { paddingTop: 8, paddingBottom: 8 },
        multiline: { padding: '8px 12px' },
        inputMultiline: { padding: 0, height: 'auto' },
      },
      MuiInputLabel: {
        root: { fontSize: 14 },
        outlined: { transform: 'translate(12px, 12px) scale(1)' },
        marginDense: { transform: 'translate(12px, 12px) scale(1)' },
      },
      MuiSelect: {
        outlined: { paddingRight: 32 },
        select: { '&:focus': { backgroundColor: 'transparent', borderRadius: baseTheme.shape.borderRadius } },
      },
      MuiFormHelperText: { root: { fontSize: 12, lineHeight: 1.5 } },
    },
  }), [baseTheme]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default EditorControlsTheme;
